import ImageCustom from 'components/ImageCustom';
import Player from 'components/Audio';
import * as React from 'react';
export default {
  ImageCustom,
  Player,
  React
};